import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=4678d6ac&scoped=true&"
import script from "./Administration.vue?vue&type=script&lang=ts&"
export * from "./Administration.vue?vue&type=script&lang=ts&"
import style0 from "./Administration.vue?vue&type=style&index=0&id=4678d6ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4678d6ac",
  null
  
)

export default component.exports